import { render, staticRenderFns } from "./InternalMagazine.vue?vue&type=template&id=90b42810&scoped=true"
import script from "./InternalMagazine.vue?vue&type=script&lang=js"
export * from "./InternalMagazine.vue?vue&type=script&lang=js"
import style0 from "./InternalMagazine.vue?vue&type=style&index=0&id=90b42810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b42810",
  null
  
)

export default component.exports